<template>
  <div class="content--sinoreg page--registroNascimento">
    <HeaderForSection class="mb-4"
                      :icone="3"
                      :prop-casamento="casamento"
                      :data-inicio="dataInicio" />

    <StepsForWizard class="my-4"
                    :ativo="wizard.ativo"
                    :passos="wizard.passos"
                    tamanho="md" />

    <div class="mt-5">
      <Conjuge v-if="wizard.ativo == 0"
               :prop-pessoa="casamento.pessoas[0]"
               :prop-ordem="0"
               :prop-cartorio="dadosCartorio"
               :prop-habilitacao="casamento"
               :prop-componente-pai="$options.name"
               @onChange="changeConjuge" />

      <Conjuge v-if="wizard.ativo == 1"
               :prop-pessoa="casamento.pessoas[1]"
               :prop-ordem="1"
               :prop-cartorio="dadosCartorio"
               :prop-habilitacao="casamento"
               :prop-componente-pai="$options.name"
               @onChange="changeConjuge" />

      <DadosCasamento v-if="wizard.ativo == 2"
                      :prop-habilitacao="casamento"
                      :prop-registro="casamento.registro"
                      :prop-cartorio="dadosCartorio"
                      :prop-tipo="'CASAMENTO'"
                      @onChange="changeDadosCasamento" />

      <Registro v-if="wizard.ativo == 3"
                :prop-registro="casamento.registro"
                @change="changeRegistro" />
    </div>

    <div class="cadastroHabilitacaoCasamento_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <b-link v-if="wizard.ativo === 0"
                  class="btn btn-sm btn-dark"
                  :to="{ name: 'rei_dashboard' }">
            Voltar
          </b-link>
          <button v-if="wizard.ativo !== 0"
                  class="btn btn-sm btn-dark"
                  type="button"
                  @click="previousStep()">
            Voltar
          </button>
        </div>

        <div class="d-inline-block ml-2">
          <button v-if="wizard.ativo < 3"
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="nextStep()">
            Continuar
          </button>

          <button v-else
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="cadastrarRegistro()">
            Cadastrar Registro
          </button>
        </div>
      </div>
    </div>
    <b-modal v-if="rascunhoFound"
             id="modalRascunho"
             ref="modalRascunho"
             no-close-on-backdrop
             no-close-on-esc
             :visible="true"
             centered
             size="xl">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Rascunho encontrado
      </div>
      <SearchRascunho :prop-rascunho="rascunhoFound" />
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-sm btn-primary"
                @click="() => { cancel(); createRascunho(); }">
          Continuar com o Cadastro
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import HeaderForSection from "@/components/SofiaRei/HeaderForSection"
  import StepsForWizard from "@/components/SofiaRei/StepsForWizard"
  import Conjuge from "@/components/SofiaRei/HabilitacaoCasamento/Conjugue"
  import DadosCasamento from "@/components/SofiaRei/HabilitacaoCasamento/DadosCasamento"
  import Registro from "@/components/SofiaRei/Casamento/Registro"
  import SearchRascunho from "@/components/SofiaRei/Busca/SearchRascunho.vue"

  /* filters */
  import { maskCPF } from '@/filters/filters'

  /* others */
  import {mapGetters} from "vuex"
  import moment from 'moment'

  /* services */
  import BuscaService from '@/services/BuscaService'
  import CartorioService from "@/services/CartorioService"
  import CasamentoService from "@/services/Registros/Casamento"
  import RegistrosService from "@/services/Registros"
  import ProtocolosService from "@/services/Protocolos"

  export default {
    name: "RegistroCasamento",
    components: {
      SearchRascunho,
      HeaderForSection,
      StepsForWizard,
      Conjuge,
      DadosCasamento,
      Registro
    },
    props: {
      propCasamento: { type: Object, default: () => ({})},
      propHabilitacao: { type: Object, default: () => ({})}
    },
    provide: function () {
      return {
        $validator: this.$validator
      }
    },
    data () {
      return {
        wizard: {
          ativo: 0,
          passos: [
            { texto: 'Cônjuge 1'},
            { texto: 'Cônjuge 2'},
            { texto: 'Dados do Casamento'},
            { texto: 'Registro' }
          ]
        },
        casamento: {
          tipo_casamento: null,
          regime_bens: null,
          casamento_em_cartorio: true,
          regime_bens_complemento: null,
          data_entrada: null,
          data_habilitacao: null,
          data_expiracao: null,
          data_casamento: null,
          hora_casamento: null,
          registro: {
            cartorio_id: this.$store.state.auth.cartorio_id,
            tipo_registro: "C",
            data_registro: moment().format('YYYY-MM-DD'),
            digitador: null,
            escrevente: null,
            origem: "novo",
            partes: [],
            local: {
              descricao: null,
              endereco: {}
            },
            oficial: null,
            livro: {}
          },
          pessoas: [
            {
              registrosAnteriores: [],
              documentos: [],
              nacionalidade_codigo: 76,
              nome: null,
              nome_novo: null,
              uf: null,
              naturalidade: null,
              idade: null,
              cpf: null,
              data_nascimento: null,
              sexo: null,
              estado_civil: 'SOLTEIRO',
              ocupacao_codigo: null,
              ocupacao_declarada: null,
              ocupacao: {},
              genitores: [],
              endereco: null
            },
            {
              registrosAnteriores: [],
              documentos: [],
              nacionalidade_codigo: 76,
              nome: null,
              nome_novo: null,
              uf: null,
              naturalidade: null,
              idade: null,
              cpf: null,
              data_nascimento: null,
              sexo: null,
              estado_civil: 'SOLTEIRO',
              ocupacao_codigo: null,
              ocupacao_declarada: null,
              ocupacao: {},
              genitores: [],
              endereco: null
            },
          ],
          cartorio: {},
          ...this.propCasamento
        },
        dataInicio: '',
        dadosCartorio: {},
        time: null,
        rascunhoCriado: false,
        showModalRascunho: false,
        rascunhoFound: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    watch: {
      $route: function () {
        // verificar mudança de rota
        if (this.$route.params.id !== 'novo') {
          this.getRascunho()
        }
      },
      propHabilitacao ()  {
        if (Object.values(this.propHabilitacao).length) {
          this.tratarConversao(this.propHabilitacao)
        }
      },
      propCasamento ()  {
        if (Object.values(this.propCasamento).length) {
          this.casamento = this.propCasamento
        }
      }
    },
    created () {
      if (Object.values(this.propCasamento).length) {
        this.casamento = this.propCasamento
      }

      if (Object.values(this.propHabilitacao).length) {
        this.tratarConversao(this.propHabilitacao)
      }

      if (this.$route.params.id !== 'novo') {
        this.getRascunho()
      }

      this.getCartorio()

      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    methods: {
      async getCartorio () {
        const cartorio = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
        this.dadosCartorio = cartorio.data

        this.casamento.cartorio = cartorio.data

        this.casamento.registro.oficial = cartorio.data.nome_oficial
      },
      changeConjuge (conjuge) {
        if (!conjuge.pessoa.nome && !conjuge.pessoa.nome_antigo) return
        //this.casamento.pessoas = []
        this.casamento.pessoas[conjuge.ordem] = conjuge.pessoa

        this.verifyRascunho()
      },
      changeDadosCasamento (casamento) {
        this.casamento = casamento

        if (casamento.tipo_casamento == 'Casamento Religioso com efeito civil' || casamento.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') this.casamento.registro.tipo_registro = "CR"
        else this.casamento.registro.tipo_registro = "C"

        this.verifyRascunho()
      },
      changeRegistro (registro) {
        this.casamento.registro = registro

        this.verifyRascunho()
      },
      async verifyRascunho () {
        const { id } = this.$route.params

        if (!this.casamento.pessoas[0].nome_antigo) return

        if (id === 'novo') {
          this.searchRascunho()
        } else {
          this.updateRascunho(id)
        }
      },
      async searchRascunho () {
        this.rascunhoFound = await BuscaService.searchRascunhoBeforeSave(this.casamento.registro, this.casamento.pessoas[0])
        if (this.rascunhoFound) {
          this.showModalRascunho = true
        } else {
          this.createRascunho()
        }
      },
      async createRascunho () {
        if (this.rascunhoCriado) return

        try {
          this.rascunhoCriado = true

          loader({active: true, text: 'Criando rascunho...'})

          const rascunho = await RegistrosService.storeRascunho({ document: this.casamento })

          this.$router.push({
            name: 'registro_casamento',
            params: {
              id: rascunho.rascunho_id,
              propCasamento: rascunho.document
            }
          }).then(() => {
            this.$toast.success('Rascunho criado com sucesso!', {
              position: 'top-right',
              duration: 5000
            })
          })
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro ao criar rascunho!', message.message)

          this.rascunhoCriado = false
        } finally {
          loader({active: false, text: ''})
        }
      },
      async updateRascunho (id) {
        try {
          await RegistrosService.updateRascunho(id, { document: this.casamento })
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro ao atualizar rascunho!', message.message)
        }
      },
      async getRascunho () {
        try {
          loader({ text: "Carregando rascunho...", active: true })
          const { document } = await RegistrosService.getRascunhoById(this.$route.params.id)
          if (typeof document == "object") {

            this.casamento = document

            if (!this.casamento.registro.livro) this.casamento.registro.livro = {}

            this.rascunhoCriado = true

            window.scrollTo({top: 0, behavior: 'smooth'})
          } else {
            this.$router.push('/pagina-nao-encontrada')
          }
        } finally {
          loader({ active: false})
        }
      },
      async nextStep () {
        await this.$validator.validateAll()

        if (this.$route.params.id === 'novo') {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        const invalids = document.querySelectorAll('.is-invalid')

        if (invalids.length) {
          invalids[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        } else {
          this.wizard.ativo++
          window.scrollTo({top: 0, behavior: 'smooth'})
        }
      },
      previousStep () {
        this.wizard.ativo--
        window.scrollTo({top: 0, behavior: 'smooth'})

      },
      displaySuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = null

        return Swal.fire(objSwal.success).then(res => {
          objSwal.success.title = null
          objSwal.success.text = null
          objSwal.success.html = null

          return res
        })
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao cadastrar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      async cadastrarRegistro () {
        const menores = []

        this.casamento.pessoas.forEach(pessoa => {
          if (pessoa.idade && pessoa.idade < 16) {
            menores.push(pessoa.nome_antigo)
          }
        })

        if (menores.length) {
          const resp = await displayMessage('question', 'Alerta!', `Existem contraentes com idade inferior a 16 anos. Tem certeza que deseja continuar?`)

          if (!resp.value) {
            return
          }
        }

        const valid = await this.$validator.validateAll()

        if (!valid) return

        try {
          loader({active: true, text: 'Cadastrando registro...'})

          const { id } = this.$route.params
          this.casamento.rascunho_id = id

          let data_atual = null

          if (this.casamento.tipo_casamento == 'Afixação de edital de outra serventia') {
            data_atual = moment().format('YYYY-MM-DD')
          }

          // caso não tenha data casamento vai ser a atual (data atual só vai ter se for 'Afixação de edital de outra serventia')
          this.casamento.registro.data_ocorrido = this.casamento.data_casamento || data_atual
          this.casamento.registro.hora_ocorrido = this.casamento.hora_casamento || moment().format('H:mm')

          const res = await CasamentoService.storeCasamento(this.casamento)

          if (res) {
            if (this.casamento.protocolo) {
              await ProtocolosService.cumprir({ ...this.casamento.protocolo, data_cumprimento: moment().format('YYYY-MM-DD') }).catch(async () => {
                await displayMessage('error', 'Erro!', 'Não foi possivel cumprir o protocolo de habilitação de casamento')
              })
            }

            this.displaySuccess(null, 'Registro cadastrado com sucesso.').then(() =>  {
              this.$router.push({name: 'resumo_casamento', params: {id: res.casamento_id, gerarOS: true}})
                .catch(() => {
                  this.$router.push('/')
                })
            })
          }
        } catch (error) {
          try {
            if (!error.response) {
              console.error(error)
              return this.displayError('TEXT', error)
            } else {
              if (Array.isArray(error.response.data)) {
                const messages = []

                error.response.data.forEach(resp => {
                  switch (resp.message) {
                  case 'unique validation failed on obito.numero_declaracao_obito':
                    messages.push(`A D.O ${this.dados.numero_declaracao_obito} já está vinculada à outro registro`)
                    break
                  case 'required validation failed on registro.oficial':
                    messages.push(`É necessário cadastrar o oficial no menu de serventia.`)
                    break
                  case 'sofia validation failed on obito.numero_declaracao_obito':
                    messages.push(`D.O Número ${this.dados.numero_declaracao_obito} não é válida.`)
                    break
                  }
                })

                const textSwal = `<ul>${messages.map(res => {
                  return `<li>${res}</li>`
                })}</ul>`

                const html = textSwal.replace(/\,/g,'')

                return this.displayError('HTML', html)
              }
              if (error.response.data.message && !error.response.data.message.message) {
                return this.displayError('TEXT', error.response.data.message).then(() => {
                  const msgs = [
                    'Configuração do Livro inválida!',
                    'Sequência do Livro inválida!',
                    'Sequências dos livros',
                    'Configurações dos livros'
                  ]

                  if (msgs.includes(error.response.data.message)) {
                    this.$router.push({ name: 'cadastro_serventia', params: { propConfigLivro: true }})
                  }
                })
              } else if (error.response.data && error.response.data.error && error.response.data.error.message) {
                if (error.response.data.error.message.match(/.*pessoa_cpf_unique.*/)) {
                  const duplicate = error.response.data.error.message.match(/Duplicate entry (.*)/)[1]
                  const cpf = duplicate.split(' ')[0]
                  return this.displayError('TEXT', `Já existe uma pessoa cadastrada com o cpf ${cpf}`)
                }
              }

              if (error.response.data && error.response.data.error) {
                return this.displayError('TEXT', error.response.data.error.message)
              }
            }
          } catch (error) {
            const text  = 'Houve algum erro ao cadastrar um novo registro de óbito, favor contactar o suporte.'

            return this.displayError('TEXT', text)
          }
        } finally {
          loader({ text: '', active: false })
          delete objSwal.error.html
        }
      },
      async tratarConversao (habilitacao) {
        try {
          loader({ active: true })

          // verificamos se já existe um rascunho para essa conversão
          const { data: { docs } } = await BuscaService.searchRascunhoREI({
            habilitacao_casamento_id: habilitacao.habilitacao_casamento_id,
            cartorio_id: this.$store.state.auth.cartorio_id,
            tipo_registro: (habilitacao.tipo_casamento == 'Casamento Religioso com efeito civil' || habilitacao.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') ? 'CR' : 'C'
          })

          if (docs.length > 0) {
            // se existir um rascunho para essa habilitação
            // será redirecionado para ele ao invés de criar um novo

            // pegando rascunho_id
            const [{ rascunho_id }] = docs

            // redirecionando
            this.$router.push({name: 'registro_casamento', params: { id: rascunho_id }})

            this.displaySuccess(null, 'Redirecionado para rascunho existente!')
            return
          }

          this.casamento = {
            ...habilitacao,
            pessoas: this.tratarPessoas(habilitacao.registro.pessoas),
            registro: {
              ...habilitacao.registro,
              registro_id: null,
              cartorio_id: this.$store.state.auth.cartorio_id,
              tipo_registro: (habilitacao.tipo_casamento == 'Casamento Religioso com efeito civil' || habilitacao.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') ? 'CR' : 'C',
              origem: 'novo',
              termo: null,
              matricula: null,
              livro_id: null,
              livro: {},
              lado: null,
              folha: null,
              data_registro: habilitacao.data_casamento ? moment(habilitacao.data_casamento).format('YYYY-MM-DD') : habilitacao.registro.data_registro,
              created_at: null,
              updated_at: null,
            },
            registro_id: null,
            created_at: null,
            updated_at: null,
          }

          this.tratarData()

          this.displaySuccess(null, 'Conversão realizada com sucesso!').then(() => {
            this.createRascunho()
          })
        } catch (error)  {
          console.error(error)
        } finally {
          loader({ active: false })
        }
      },
      tratarData () {
        if (this.casamento.data_casamento) {
          this.casamento.data_casamento = moment(this.casamento.data_casamento).format('YYYY-MM-DD')
        }
      },
      tratarPessoas (pessoas) {
        return pessoas.map(pessoa => {
          if (pessoa.cpf) pessoa.cpf = maskCPF(pessoa.cpf)

          return pessoa
        })
      }
    }
  }
</script>

<style scoped>

</style>
